import api from '@/api/index.js'

const reporting_profile_report = {
  state: {
    loading: false,
    error: null,
    ticketsReportData: null
  },

  mutations: {
    SET_REPORTING_PROFILE_REPORT_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_REPORTING_PROFILE_TICKETS_REPORT: (state, data) => {
      state.ticketsReportData = data
    },
    SET_REPORTING_PROFILE_REPORT_ERROR: (state, data) => {
      state.error = data
    },
  },

  actions: {
    MakeReportingProfileJourneysReport({commit}, payload) {
      commit('SET_REPORTING_PROFILE_REPORT_LOADING', true)
      return api.file(`reporting-profiles/${payload.profile_id}/report/journeys?from=${payload.from}&to=${payload.to}`)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
    },
    MakeReportingProfileTopUpsReport({commit}, payload) {
      commit('SET_REPORTING_PROFILE_REPORT_LOADING', true)
      return api.file(`reporting-profiles/${payload.profile_id}/report/top-ups?from=${payload.from}&to=${payload.to}`)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
    },
    MakeReportingProfileMoneyClaimsReport({commit}, payload) {
      commit('SET_REPORTING_PROFILE_REPORT_LOADING', true)
      return api.file(`reporting-profiles/${payload.profile_id}/report/money-claims?from=${payload.from}&to=${payload.to}`)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
    },
    MakeReportingProfileBalanceReport({commit}, payload) {
      commit('SET_REPORTING_PROFILE_REPORT_LOADING', true)
      return api.file(`reporting-profiles/${payload.profile_id}/report/balance?to=${payload.to}`)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
        })
    },
    GetTicketsReportFromReportingProfile({commit}, payload) {
      commit('SET_REPORTING_PROFILE_REPORT_ERROR', null)
      commit('SET_REPORTING_PROFILE_REPORT_LOADING', true)
      commit('SET_REPORTING_PROFILE_TICKETS_REPORT', null)
      return api.get(`reporting-profiles/${payload.profile_id}/report/tickets?from=${payload.from}&to=${payload.to}&fare_group_id=${payload.fare_group_id}&operator_id=${payload.operator_id}`)
        .then((response) => {
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
          commit('SET_REPORTING_PROFILE_TICKETS_REPORT', response)
        })
        .catch((error) => {
          commit('SET_REPORTING_PROFILE_REPORT_LOADING', false)
          commit('SET_REPORTING_PROFILE_REPORT_ERROR', error.body)
          commit('SET_ERROR', error.body)
        })
    }
  }
}

export default reporting_profile_report
